<ng-container>
  <!-- <ion-button class="close-tour" slot="end" fill="clear" color="light" (click)="cancelTour()">
        <ion-icon name="close-circle-outline"></ion-icon>
    </ion-button> -->
  <swiper
    #quickTourSwiper
    class="quick-tour-swiper"
    [config]="swiperConfig"
    [slidesPerView]="1"
    [spaceBetween]="0"
    [virtual]="true"
    [pagination]="{ clickable: true }"
    (activeIndexChange)="onSlideChange($event)"
  >
    <ng-container *ngFor="let page of quickTourPages; index as i">
      <ng-template swiperSlide let-data [ngSwitch]="page.type">
        <div class="video-container" *ngIf="page.animation">
          <!-- TODO: Add Lottie animation -->
          <!-- Please add video animation in the folder (../assets/videos)
            and file name should be quick-tour-<type_name>, (.mov extension) -->
          <video #videoPlayer autoplay loop playsinline width="100%">
            <source
              [src]="'../../assets/videos/quick-tour-' + page.type + '.mov'"
              type="video/mp4"
            />
          </video>
        </div>
        <div class="image-container" *ngIf="page.image">
          <img
            [src]="'../../assets/images/quick-tour-' + page.type + '.png'"
            alt="quick-tour-intro-image-from-undraw"
            border="0"
          />
        </div>
        <ion-card>
          <ion-card-header>
            <ion-card-title> {{ page.title }} </ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <h4>{{ page.subtitle }}</h4>
            <br />
            <img
              *ngIf="getSVGIcon(page.type)"
              [src]="getSVGIcon(page.type)"
              [alt]="page.type"
            />
            <h5 style="margin-top: 4px">
              {{ page.details }}
            </h5>
          </ion-card-content>
        </ion-card>
      </ng-template>
    </ng-container>
  </swiper>

  <!-- Quick tour buttons container -->
  <div class="quick-tour-buttons-container">
    <div
      *ngIf="activePageIndex == 0"
      class="start-page-buttons direction-column"
    >
      <ion-button fill="light" (click)="nextSlide($event)">
        {{ 'QUICK_TOUR.BUTTONS.LETS_START' | translate }}
      </ion-button>
      <ion-button class="link small" fill="clear" (click)="skipTour($event)">
        {{ 'QUICK_TOUR.BUTTONS.SKIP' | translate }}
      </ion-button>
    </div>
    <div
      *ngIf="activePageIndex > 0 && activePageIndex < quickTourPages.length - 1"
      class="default-buttons"
    >
      <ion-button (click)="prevSlide($event)">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button (click)="nextSlide($event)">
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
    <div
      *ngIf="activePageIndex == quickTourPages.length - 1"
      class="final-page-buttons direction-column"
    >
      <ion-button fill="light" (click)="finishTour($event)">
        {{ 'QUICK_TOUR.BUTTONS.FINISH' | translate }}
      </ion-button>
    </div>
  </div>

  <!-- Quick Tour Pagination -->
  <div class="quick-tour-pagination">
    <span
      *ngFor="let page of quickTourPages; let i = index"
      (click)="goToSlide(i)"
      [ngClass]="
        i == activePageIndex
          ? 'swiper-pagination-bullet-active'
          : 'swiper-pagination-bullet'
      "
    ></span>
  </div>
</ng-container>
